export const PropertyTypesWeBuy = () => {
  const propertyTypes = [
    {
      icon: 'ri-store-2-line',
      title: 'Retail + Residential',
      description: 'Ground floor retail with apartments above—the classic mixed-use configuration in urban areas.',
      features: ['Street-level retail', 'Walk-up or elevator', 'High foot traffic', 'Diverse tenant mix']
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Office + Residential',
      description: 'Professional office space combined with residential units, popular in downtown and suburban centers.',
      features: ['Professional tenants', 'Daytime activity', 'Parking requirements', 'Flexible spaces']
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Restaurant + Residential',
      description: 'Properties with restaurant or food service on ground floor and apartments above.',
      features: ['Food service tenants', 'Specialized systems', 'Extended hours', 'High visibility']
    },
    {
      icon: 'ri-building-4-line',
      title: 'Multi-Use Buildings',
      description: 'Properties combining three or more uses such as retail, office, and residential spaces.',
      features: ['Complex management', 'Diverse income', 'Urban locations', 'High value potential']
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Types of Mixed-Use Properties We Buy
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We purchase all types of mixed-use properties, from simple retail/residential combinations to complex multi-use developments.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {propertyTypes.map((type, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-8 hover:shadow-xl transition-all duration-300">
              <div className="flex items-start mb-6">
                <div className="w-14 h-14 flex items-center justify-center bg-teal-500 text-white rounded-lg mr-4 flex-shrink-0">
                  <i className={`${type.icon} text-2xl`}></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-2 text-gray-900">{type.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{type.description}</p>
                </div>
              </div>
              <div className="border-t border-gray-300 pt-6">
                <h4 className="font-semibold mb-3 text-gray-900">Key Features:</h4>
                <ul className="grid grid-cols-2 gap-3">
                  {type.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-gray-700">
                      <i className="ri-check-line text-teal-500 mr-2"></i>
                      <span className="text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-2xl p-8 md:p-12 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl font-bold mb-6">Have a Unique Mixed-Use Property?</h3>
            <p className="text-xl mb-8 text-white/95 leading-relaxed">
              Every mixed-use property is different. Whether you have a straightforward retail/residential building or a complex multi-use development, we'd like to evaluate it. Our team can handle any mixed-use configuration and provide a fair, competitive offer.
            </p>
            <a 
              href="#get-offer" 
              className="whitespace-nowrap inline-block bg-white text-teal-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
            >
              Tell Us About Your Property
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};